<template>
  <div class="flex flex-col md:flex-row gap-2 md:gap-5">

    <!-- Left Section: Current Subscription -->
    <div class="flex-1 flex flex-col p-4 bg-onvocado-white rounded-xl">
      <template v-if="currentPlan">
        <div class="flex justify-between">
          <span class="text-sm">Your plan</span>
          <img class="h-8 w-8" src="/onvocado_logo.png" alt="Onvocado Logo">
        </div>
        <div class="mb-8">
          <span class="mb-2 block font-bold text-2xl capitalize">onvocado {{ currentPlan.type + ' ' +
          currentPlan.billingPeriod }}</span>
          <div v-if="!hasCanceledSubscription">
            <span class="mb-2 block">Your next bill is for <b>{{ currentPlan.price }}</b> <b
                class="uppercase">{{ currentPlan.currency }}</b> on <b>{{ $parseDate(currentPlan.expiresAt)
              }}</b></span>
            <span class="mb-2 block">
              <span v-if="isCardPayment">Card ending in {{ currentPlan.lastFourDigits }}</span>
              <!--              <span v-else>Payment method: <b>PayPal</b></span>-->
            </span>
          </div>
        </div>
        <div class="mt-auto">
          <span v-if="!hasCanceledSubscription" class="mb-1.5 block">Subscription started on <b>{{ $parseDate(
              currentPlan.firstBillingDate) }}</b></span>
          <span v-else class="mb-1.5 block">Subscription expires on
            <b>{{ $parseDate(currentPlan.cancelsAt) }}</b></span>
          <span v-if="hasCanceledSubscription" class="mb-1.5 block text-onvocado-primary">
            To renew your subscription
            <button class="underline"
                    @click.prevent="$emit('subscription-renew', currentPlan.id, currentPlan.stripePriceId)">
              Click here!
            </button>
          </span>
        </div>
      </template>
    </div>

    <!-- Right Section: Next Plan/Upgrade -->
    <div class="p-4 flex-shrink-0 bg-onvocado-white rounded-xl">
      <template v-if="currentPlan && nextPlan">
        <span class="text-sm mb-1">Upgrade to</span>
        <span class="mb-4 block font-bold text-2xl capitalize">{{ nextPlan.type }}</span>
        <div v-for="feature in nextPlan.features" :key="feature" class="flex items-center mb-2">
          <i class="el-icon-check text-onvocado-secondary mr-2"></i>
          <h5 class="font-medium dark:text-gray-300">{{ plansMeta.features[feature] }}</h5>
        </div>
        <button class="btn contrast mt-4"
                type="button"
                :disabled="hasCanceledSubscription"
                @click.prevent="$emit('subscription-change', nextPlan.id, nextPlan.stripePriceId)">Upgrade
        </button>
      </template>
      <template v-else>
        <span class="mb-4 block font-bold text-2xl capitalize">Features</span>
        <div v-for="feature in currentPlan.features" :key="feature" class="flex items-center mb-2">
          <i class="el-icon-check text-onvocado-secondary mr-2"></i>
          <h5 class="font-medium dark:text-gray-300">{{ plansMeta.features[feature] }}</h5>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import plansMixins from '@mixins/plans'

export default {
  name: 'CurrentSubscriptionOverview',
  inject: ['$parseDate'],
  mixins: [plansMixins],
  props: {
    currentPlan: {
      type: Object,
      required: true,
    },
    hasCanceledSubscription: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  computed: {
    ...mapGetters('plans', [
      'getNextPlanItemByCurrentPlanID',
    ]),
    nextPlan() {
      return this.getNextPlanItemByCurrentPlanID(this.currentPlan)
    },
    currencySymbol() {
      return this.currentPlan.currency === 'eur' ? '€' : '$'
    },
    isCardPayment() {
      return this.currentPlan.lastFourDigits !== 'No cards available'
    },
  },
}
</script>
